'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var React = require('react');
var index = require('../node_modules/prop-types/index.js');
var Slide = require('@material-ui/core/Slide');
var Collapse = require('@material-ui/core/Collapse');
var Alert = require('@material-ui/core/Alert');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

function _interopNamespace(e) {
  if (e && e.__esModule) return e;
  var n = Object.create(null);
  if (e) {
    Object.keys(e).forEach(function (k) {
      if (k !== 'default') {
        var d = Object.getOwnPropertyDescriptor(e, k);
        Object.defineProperty(n, k, d.get ? d : {
          enumerable: true,
          get: function () {
            return e[k];
          }
        });
      }
    });
  }
  n['default'] = e;
  return Object.freeze(n);
}

var React__namespace = /*#__PURE__*/_interopNamespace(React);
var Slide__default = /*#__PURE__*/_interopDefaultLegacy(Slide);
var Collapse__default = /*#__PURE__*/_interopDefaultLegacy(Collapse);
var Alert__default = /*#__PURE__*/_interopDefaultLegacy(Alert);

var MAX_DURATION = 7000;
var MIN_DURATION = 2000;
var MS_PER_CHARACTER = 50;
/**
 * Calculates the length of time in milliseconds a snackbar message will
 * appear based on the length of the text.
 *
 * @param {string} text The text value of the message
 * @returns {number} Duration the message will appear in milliseconds
 */

function getMessageDuration() {
  var text = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  return Math.max(Math.min(text.length * MS_PER_CHARACTER, MAX_DURATION), MIN_DURATION);
}

var SnackbarMessage = _ref => {
  var {
    text,
    type,
    kill,
    shouldMakeRoom
  } = _ref;
  var [isOnScreen, setIsOnScreen] = React__namespace.useState(true);
  var [isFullHeight, setIsFullHeight] = React__namespace.useState(true); // On mount, start a timeout for the calculated duration of the message.

  React__namespace.useEffect(() => {
    var interval = setTimeout(() => {
      setIsOnScreen(false);
    }, getMessageDuration(text));
    return () => clearTimeout(interval);
  }, []);
  return /*#__PURE__*/React__namespace.createElement(Collapse__default['default'], {
    in: isFullHeight,
    onExited: () => kill()
  }, /*#__PURE__*/React__namespace.createElement(Slide__default['default'], {
    in: isOnScreen && !shouldMakeRoom,
    direction: "right",
    onExited: () => setIsFullHeight(false)
  }, /*#__PURE__*/React__namespace.createElement(Alert__default['default'], {
    sx: {
      marginTop: 1,
      maxWidth: 300
    },
    onClose: () => setIsOnScreen(false),
    severity: type
  }, text)));
};
SnackbarMessage.propTypes = {
  /** The text value of the message. */
  text: index.string,

  /** The message type. */
  type: index.oneOf(['info', 'success', 'warning', 'error']),

  /** Callack to remove the message from the message queue. */
  kill: index.func,

  /**
   * If `true`, `isOnScreen` will be set to false and start the removal of the
   * message.
   */
  shouldMakeRoom: index.bool
};

exports.SnackbarMessage = SnackbarMessage;
exports.default = SnackbarMessage;
